import Routes from './Routes';

interface RoutePath {
    [other: string]: string
}

export class Constants {

    public static API_KEY = "apiKey";
    public static BASE_NUMBER = 50;
    public static MIN_ALLOWED_BET_AMOUNT = 0.00001;
    public static USER_CLIENT_SEED = "activeClientSeed";
    public static MAX_ALLOWED_BET_AMOUNT = 1;
    public static LOGIN_STATE_REMEMBRANCE = "login_state_rememberance";
    public static readonly MULTIPLY_BTC_GAME = "6/49";
    public static readonly SITE_KEY = "6LdxmjkaAAAAAHH_f6lpjX8nh7_tR3Q3jd-YY9hA";
    public static readonly FREE_ROLL_PAGE = "free_roll_page";
    public static readonly TITLE = "title";
    public static readonly DESCRIPTION = "description";
    public static readonly TITLE_COLOR = "title_color";
    public static readonly DESCRIPTION_COLOR = "description_color";
    public static readonly SCROLL_TO_HOW = "scroll_to_how";
    public static readonly LOGIN_STATE = "login_state";
    public static readonly AUTH_EMAIL = "auth_email";
    public static readonly AUTH_PASSWORD = "auth_password";

    public static readonly REGISTERED_USERS_COUNT = "registered_users_count";
    public static readonly LOGGED_IN_USER_DATA_CHANGED = "logged_in_user_data_change";
    public static readonly LOGGED_IN_USER_DATA = "logged_in_user_data";
    public static readonly COOKIE_NAME = "coinvineyard1992ZigmaLock";
    public static readonly ACTIVE_OPERATION_STATUS = "op_status";

    public static readonly LOGIN_CREDENTIALS_CHANGED = "log_in_credentials_changed";
    public static readonly START_LOGIN = "start_login";
    public static readonly LOGIN_STATE_CHANGED = "login_state_changed";
    public static readonly REMEMBER_ME = "remember_me";

    public static readonly ACTION_DISPLAY_PROVABLY_FAIR_PAGE = "action_display_provably_fair_page";
    public static readonly PROVABLY_FAIR_INIT_DATA = "provably_fair_init_data";
    public static readonly ACTION_ORIGINATOR = "action_creator";
    public static readonly OPEN = "open";

    public static readonly TopTabAndRoutes: RoutePath = {
        "Free BTC": Routes.FREE_BTC,
        "Multiply BTC": Routes.MULTIPLY_BTC,
        "Earn BTC": Routes.EARN_BTC,
    };

    public static readonly BottomTabAndRoutes: RoutePath = {
        "FreeBTC": Routes.FREE_BTC,
        "Multiply BTC": Routes.MULTIPLY_BTC,
        "Earn BTC": Routes.EARN_BTC,
    };
    public static UPDATE_COST_PER_TICKET = "update_cost_per_ticket";
    public static COST_PER_TICKET = "cost_per_ticket";
    public static BET_TYPE_CHANGED = "bet_type_changed";
    public static BET_TYPE = "bet_type";
    public static TICKETS_CHANGED = "tickets_changed";
    public static TICKETS = "tickets";
    static ACTIVE_GAMES = "active_games";
    static REFERER = "r";
    static WITHDRAWAL_AMOUNT = "withdrawal_amount";
    static AFTER_ONE_CONFIRMATION_REF_LINK = "https://www.buybitcoinworldwide.com/confirmations/"
    static WITHDRAWAL_ADDRESS = "withdrawal_address";
    static PASSWORD = "password";
    static EMAIL = "email";
    static USERNAME = "username";
    static CAN_SHOW_ONLY_MY_STATS="can_show_only_my_stats";
}